import { Component, Inject, Input, OnInit } from '@angular/core'
import { saveAs } from 'file-saver'
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog'
import { ApiCall } from '@shared/async-services/http/api-call.service'

export interface DialogData {
  title: string;
  message: string;
  loading: boolean;
  btnHide: boolean;
}

@Component({
  selector: 'app-download-dialog',
  templateUrl: './download-dialog.component.html',
  styleUrls: ['./download-dialog.component.scss'],
})
export class DownloadDialogComponent implements OnInit {
  loading: boolean;
  dialogData: DialogData;
  title: string;
  blob: Blob;
  message: string;
  btnHide: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DownloadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private auth: ApiCall,
    public dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.downloadUser();
  }

  ok(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }

  downloadUser() {
    this.loading = true;
    this.dialogRef.disableClose = true;
    this.auth.downloadUsersUnderOrganization().subscribe(
      (res) => {
        this.blob = new Blob([res], { type: 'application/xlsx' })
        saveAs(this.blob, 'users.xlsx')
        this.data.message = 'Users downloaded succesfully!'
      },
      (error) => {
        console.error('Error while downloading the users, ', error)
        this.data.message = 'Error while downloading the users'
      },
      () => {
        this.loading = false;
        this.btnHide = true;
        this.dialogRef.disableClose = false;
      },
    )
  }
}
